import React, { useEffect } from 'react';
import googleAnalytics from '../services/googleAnalytics';
import { authService } from '../services/auth';

interface AnalyticsProviderProps {
  children: React.ReactNode;
}

/**
 * Analytics Provider
 * Initializes Google Analytics and identifies users
 */
export const AnalyticsProvider: React.FC<AnalyticsProviderProps> = ({ children }) => {

  useEffect(() => {
    // Initialize Google Analytics
    googleAnalytics.init();

    // Identify user if logged in
    const identifyUser = async () => {
      try {
        const user = await authService.initialize();
        if (user) {
          const userProperties = {
            email: user.email,
            name: user.displayName || `${user.firstName || ''} ${user.lastName || ''}`.trim(),
            isAdmin: user.isAdmin,
            createdAt: user.createdAt,
          };

          // Identify in Google Analytics
          googleAnalytics.identify(user.id, userProperties);
        }
      } catch (error) {
        console.error('Error identifying user for analytics:', error);
      }
    };

    identifyUser();

    // Track app initialization
    googleAnalytics.track('app_initialized', {
      category: 'App',
      timestamp: new Date().toISOString(),
    });
  }, []);

  return <>{children}</>;
};

export default AnalyticsProvider;
